import { Component, Input } from '@angular/core';

@Component({
  selector: 'icons',
  template: `
        <div [ngSwitch]="icon">
            <beach-icon *ngSwitchCase="'beach'"></beach-icon>
            <nature-icon *ngSwitchCase="'nature'"></nature-icon>
            <cultural-icon *ngSwitchCase="'cultural'"></cultural-icon>
            <fun-icon *ngSwitchCase="'fun'"></fun-icon>
            <events-icon *ngSwitchCase="'events'"></events-icon>
            <holiday-icon *ngSwitchCase="'holiday'"></holiday-icon>
            <sports-icon *ngSwitchCase="'sports'"></sports-icon>
            <buys-icon *ngSwitchCase="'buys'"></buys-icon>
            <travel-itineraries-icon *ngSwitchCase="'travel-itineraries'"></travel-itineraries-icon>
            <unmissable-icon *ngSwitchCase="'imperdibles'"></unmissable-icon>
            <image-icon *ngSwitchDefault [mediaIconUrl]="icon"></image-icon>
        </div>
    `,
  styles: [``]
})
export class IconsComponent {
  @Input() icon: string;

  constructor() { }
}


@Component({
  selector: 'beach-icon',
  template: `
        <svg xmlns="http://www.w3.org/2000/svg" width="72" height="60" viewBox="0 0 72 60">
            <g fill="none" fill-rule="evenodd" stroke="#410062" stroke-width="3.541">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19.039 57.475h51-51zm-7.236-13.691l5.451-2.833-5.45 2.833zm43.672-2.833l5.451 2.833-5.45-2.833zM2 57.475h9"/>
                <path fill="var(--brand-tertiary-3)" fill-rule="nonzero" d="M36.59 44.492c7.822 0 14.164-6.342 14.164-14.164S44.412 16.164 36.59 16.164a14.102 14.102 0 0 0-8.475 2.814 14.143 14.143 0 0 0-5.689 11.35c0 .75.06 1.485.17 2.202 1.059 6.777 6.92 11.962 13.994 11.962z"/>
                <path stroke-linecap="round" d="M8.262 28.994h5.902m43.672 0h5.902m-51.935-14.01l5.06 3.035m38.612.506l5.06-3.036m-13.322-5.227l3.036-5.06m-24.282 5.06l-3.036-5.06m13.66 2.7V2"/>
            </g>
        </svg>
    `,
  styles: [``]
})
export class BeachIconComponent {
  constructor() { }
}

@Component({
  selector: 'nature-icon',
  template: `
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="62" viewBox="0 0 40 62">
            <g fill="none" fill-rule="evenodd" stroke="#410062" stroke-linecap="round">
                <path stroke-linejoin="round" stroke-width="3" d="M11.943 59.63h16.124M20 47c-9.941 0-18-8.059-18-18 0-4.769 1.854-9.104 4.881-12.325A13.344 13.344 0 0 1 6.8 15.2C6.8 7.91 12.71 2 20 2c7.29 0 13.2 5.91 13.2 13.2 0 .499-.028.99-.081 1.475A17.938 17.938 0 0 1 38 29c0 5.27-2.265 10.01-5.874 13.303"/>
                <path stroke-width="3.36" d="M20 40.4v18" />
                <path stroke-width="3" d="M25.75 35l-4.977 4.977M24.618 19.332l-3.845 3.845"/>
                <path fill="var(--brand-tertiary-3)" stroke-linejoin="round" stroke-width="3.36" d="M20 47c-9.941 0-18-8.059-18-18 0-4.769 1.854-9.104 4.881-12.325A13.344 13.344 0 0 1 6.8 15.2C6.8 7.91 12.71 2 20 2"/>
                <path stroke-width="3" d="M13.577 25.927l5.65 5.65M20 12.8v44.4" />
            </g>
        </svg>
    `,
  styles: [``]
})
export class NatureIconComponent {
  constructor() { }
}

@Component({
  selector: 'cultural-icon',
  template: `
        <svg xmlns="http://www.w3.org/2000/svg" width="45" height="56" viewBox="0 0 45 56">
            <g fill="none" fill-rule="evenodd">
                <g stroke="#410062" stroke-width="3">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.695 13.238A6.6 6.6 0 1 1 11 2m25.2 0a6.6 6.6 0 1 1-5.074 10.821M24.8 2h12-12zM10.4 2h5.4-5.4z" />
                    <path fill="var(--brand-tertiary-3)" stroke-linecap="round" stroke-linejoin="round" d="M2 47.6h40.8m0 6H2M16.4 46.4V8h14.4v38.4z"/>
                    <path d="M16.4 14h14.4"/>
                </g>
            </g>
        </svg>
    `,
  styles: [``]
})
export class CulturalIconComponent {
  constructor() { }
}

@Component({
  selector: 'fun-icon',
  template: `
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="72" viewBox="0 0 40 72">
            <g fill="none">
                <path d="M44.92 22.452c4.492-.977 6.738-3.222 6.738-6.736 0-5.27-3.016-6.735-6.738-6.735-2.48 0-4.727 2.245-6.738 6.735h8.456l-1.718 6.736z" transform="translate(-18)"/>
                <path fill="#FFF" d="M34.881 53.884L34.881 62.637 46.08 62.637 46.082 67.355 21.375 67.355 21.375 62.648 34.881 62.648" transform="translate(-18) matrix(-1 0 0 1 67.457 0)"/>
                <path stroke="#410062" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M35.966 53.884L35.966 63.785 47.164 63.785 47.166 70.31 22.46 70.31 22.46 63.785 28.743 63.785" transform="translate(-18) matrix(-1 0 0 1 69.626 0)"/>
                <path fill="#FFF" d="M48.903 20.206c4.054-.313 7.247-3.706 7.247-7.846 0-4.346-3.52-7.87-7.86-7.87-4.342 0-7.862 3.524-7.862 7.87" transform="translate(-18)"/>
                <path stroke="#410062" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M46.827 20.199c1.249.01 1.94.01 2.076 0 4.054-.313 7.247-3.705 7.247-7.843 0-4.344-3.52-7.866-7.86-7.866-4.342 0-7.862 3.522-7.862 7.866" transform="translate(-18)"/>
                <path fill="#FFF" d="M49.412 13.471l-5.398 12.012 2.714 11.728c.389 1.233.599 2.547.599 3.91 0 7.05-5.603 12.763-12.514 12.763-6.91 0-12.513-5.714-12.513-12.762 0-1.302.19-2.559.546-3.742l2.567-11.897-5.199-12.012h29.198z" transform="translate(-18)"/>
                <path fill="var(--brand-tertiary-3)" d="M24.53 32.62l.797-3.433H44.83l2.14 11.055c1.208 6.246-3.277 12.434-9.832 13.586-.722.126-1.303 0-2.037 0-6.426 0-12.64-4.963-12.64-11.087" transform="translate(-18)"/>
                <path stroke="#410062" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M49.412 13.471l-5.398 12.012 2.714 11.728c.389 1.233.599 2.547.599 3.91 0 7.05-5.603 12.763-12.514 12.763-6.91 0-12.513-5.714-12.513-12.762 0-1.302.19-2.559.546-3.742l2.567-11.897-5.199-12.012h29.198z" transform="translate(-18)"/>
                <path stroke="#410062" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M20.214 5.279L24.762 2.245 33.69 31.432" transform="translate(-18)"/>
            </g>
        </svg>
    `,
  styles: [``]
})
export class FunIconComponent {
  constructor() { }
}

@Component({
  selector: 'events-icon',
  template: `
        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="59" viewBox="0 0 56 59">
            <g fill="none" fill-rule="evenodd" stroke="#410062">
                <path fill="#FFF" fill-rule="nonzero" stroke-linecap="round" stroke-width="3.24" d="M40.026 45.21c2.72 1.935 5.704 3.027 8.6 2.517.828-.147 1.62-.407 2.374-.765 6.92-3.29 10.612-14.85 9.29-22.34-1.24-7.033-7.181-12.075-14.092-12.553-.375-.026-.754-.038-1.134-.037" transform="translate(-7 -5)"/>
                <path fill="var(--brand-tertiary-3)" fill-rule="nonzero" stroke-width="3.6" d="M26 47c.923 0 1.828-.132 2.71-.379C36.81 44.357 43 32.421 43 23.97 43 14.598 35.388 7 26 7c-3.815 0-7.335 1.254-10.172 3.371-4.3 3.201-6.832 8.243-6.828 13.599 0 .898.07 1.779.204 2.638C10.474 34.728 17.51 47 26 47z" transform="translate(-7 -5)"/>
                <path fill="#FFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M26.016 52.984L22 57 22 49 30 49" transform="translate(-7 -5) rotate(45 26 53)"/>
                <path stroke-linecap="round" stroke-width="3" d="M26 53c.103 5.707 1.989 8.56 5.657 8.56" transform="translate(-7 -5)"/>
                <g stroke-linecap="round" stroke-width="3">
                    <path fill="#FFF" stroke-linejoin="round" d="M6.016 5.984L2 10 2 2 10 2" transform="translate(-7 -5) rotate(-15 208.687 -136.708) rotate(45 6 6)"/>
                    <path d="M6.069 6.31c.103 5.707 1.989 8.56 5.657 8.56" transform="translate(-7 -5) rotate(-15 208.687 -136.708)"/>
                </g>
            </g>
        </svg>
    `,
  styles: [``]
})
export class EventsIconComponent {
  constructor() { }
}

@Component({
  selector: 'holiday-icon',
  template: `
        <svg xmlns="http://www.w3.org/2000/svg" width="69" height="66" viewBox="0 0 69 66">
            <g fill="none" fill-rule="evenodd" transform="translate(1 2)">
                <path fill-rule="nonzero" stroke="#410062" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M9.019 46.643L57.019 46.465"/>
                <path fill="var(--brand-tertiary-3)" fill-rule="nonzero" d="M6.442 6.429h55.404c2.847 0 5.154 2.307 5.154 5.153v10.275H1.288V11.582c0-2.846 2.308-5.153 5.154-5.153z"/>
                <path fill-rule="nonzero" stroke="#410062" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M40.035 21.857h26.368v31.775l-8.42 8.644H47m-18.325 0H.8V21.857h9.176M51.538 12.857c3.558 0 6.443-2.878 6.443-6.428S55.096 0 51.538 0s-6.442 2.878-6.442 6.429"/>
                <path fill-rule="nonzero" stroke="#410062" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M38.784 7.162h22.46c2.846 0 5.153 2.308 5.153 5.154v.008h0V24.43M19.327 12.857c3.558 0 6.442-2.878 6.442-6.428S22.885 0 19.327 0c-3.558 0-6.442 2.878-6.442 6.429"/>
                <path fill-rule="nonzero" stroke="#410062" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M25.572 7.162H6.004C3.158 7.162.85 9.47.85 12.316v10.11h0M9.322 34.357L38.5 34.5" />
                <circle cx="53.5" cy="35.5" r="4.25" fill="var(--brand-tertiary-3)" stroke="#410062" stroke-width="2.5"/>
            </g>
        </svg>
    `,
  styles: [``]
})
export class HolidayIconComponent {
  constructor() { }
}

@Component({
  selector: 'sports-icon',
  template: `
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="59" viewBox="0 0 60 59">
            <g fill="none" fill-rule="evenodd" stroke="#410062">
                <path fill="var(--brand-tertiary-3)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22.65 35.737H10.105C8.943 35.737 8 34.693 8 33.404v-9.333c0-1.289.943-2.334 2.105-2.334h35.79c1.162 0 2.105 1.045 2.105 2.334v9.333c0 1.289-.943 2.333-2.105 2.333H33.617" transform="translate(2 1.263)"/>
                <path fill="#FFF" stroke-width="2.5" d="M2 25.737h2v6H2c-1.105 0-2-.895-2-2v-2c0-1.104.895-2 2-2zM54 25.737h-2 0v6h2c1.105 0 2-.895 2-2v-2c0-1.104-.895-2-2-2z" transform="translate(2 1.263)"/>
                <path stroke-linecap="round" stroke-width="2.5" d="M28 48.737c0 3.77 3.055 6.825 6.824 6.825H46c5.523 0 10-4.478 10-10V27.78h0V0h-4v5.603h3.167" transform="translate(2 1.263)"/>
                <path fill="#FFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M32.004 46.737L34 46.737 34 50.737 22 50.737 22 46.737 28.952 46.737" transform="translate(2 1.263)"/>
                <path stroke-linejoin="round" stroke-width="2.5" d="M10 17.737h36c3.314 0 6 2.687 6 6v10c0 3.314-2.686 6-6 6H32.84c-.522 0-1.024-.204-1.398-.57l-3.506-3.43h0l-3.333 3.4c-.377.384-.891.6-1.429.6H10c-3.314 0-6-2.686-6-6v-10c0-3.313 2.686-6 6-6z" transform="translate(2 1.263)"/>
            </g>
        </svg>
    `,
  styles: [``]
})
export class SportsIconComponent {
  constructor() { }
}

@Component({
  selector: 'buys-icon',
  template: `
        <svg xmlns="http://www.w3.org/2000/svg" width="55" height="67" viewBox="0 0 55 67">
            <g fill="none" fill-rule="evenodd" stroke="#410062" stroke-width="2.5">
                <path fill="#FFF" d="M2.956 20h34.088c.535 0 .975.42 1 .955l1.908 42c.026.551-.401 1.019-.953 1.044l-.045.001H1.046c-.552 0-1-.448-1-1 0-.015 0-.03.002-.045l1.909-42c.024-.534.464-.955.999-.955z" transform="translate(2 1)"/>
                <path fill="var(--brand-tertiary-3)" d="M38 20h9.089c1.07 0 1.95.841 1.998 1.91l1.818 40c.05 1.103-.804 2.038-1.907 2.088l-.091.002H40h0l-2-44z" transform="translate(2 1)"/>
                <path stroke-linecap="round" d="M44.5 38.693L45.5 64" transform="translate(2 1)"/>
                <path d="M29 1.25c-2.14 0-4.078.867-5.48 2.27-1.403 1.402-2.27 3.34-2.27 5.48v10.75h15.5V9c0-2.14-.867-4.078-2.27-5.48-1.402-1.403-3.34-2.27-5.48-2.27z" transform="translate(2 1)"/>
                <path stroke-linecap="round" d="M13 26V10c0-4.97 4.03-9 9-9s9 4.03 9 9v12.81" transform="translate(2 1)"/>
                <path fill="var(--brand-tertiary-3)" d="M9.414 29.7l3.131-2.26c.36-.26.85-.252 1.2.022l2.87 2.238c.243.19.385.48.385.788V39c0 .552-.448 1-1 1h-6c-.552 0-1-.448-1-1v-8.489c0-.32.154-.622.414-.81z" transform="translate(2 1)"/>
            </g>
        </svg>
    `,
  styles: [``]
})
export class BuysIconComponent {
  constructor() { }
}

@Component({
  selector: 'travel-itineraries-icon',
  template: `
       <svg mlns="http://www.w3.org/2000/svg" width="36" height="41" viewBox="0 0 36 41">
            <g fill="none" transform="translate(-18 -16)">
                <path fill="var(--brand-tertiary-3)" d="M36 18l.319.003C45.009 18.171 52 25.178 52 33.798 52 42.523 37.694 55 36 55c-1.694 0-16-12.477-16-21.202C20 25.073 27.163 18 36 18z"/>
                <path stroke="#410062" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M36 55c-1.694 0-16-12.477-16-21.202M36 18c8.837 0 16 7.073 16 15.798S37.694 55 36 55"/>
                <circle cx="36" cy="32" r="4" fill="#410062"/>
            </g>
        </svg>
    `,
  styles: [``]
})
export class TravelItinerariesIconComponent {
  constructor() { }
}

@Component({
  selector: 'unmissable-icon',
  template: `
        <svg xmlns="http://www.w3.org/2000/svg" width="55" height="67" viewBox="0 0 55 67">
            <g fill="none" fill-rule="evenodd">
                <path fill="#FFF" d="M38.78 45.497c11.215-5.83 15.58-19.648 9.749-30.863C42.699 3.42 28.88-.945 17.666 4.886 6.45 10.716 2.086 24.534 7.917 35.749c5.83 11.214 19.649 15.579 30.863 9.748z" transform="translate(1 1)"/>
                <path stroke="#410062" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M40.956 49.682C27.43 56.714 10.765 51.45 3.733 37.924-3.3 24.4 1.965 7.734 15.49.701" transform="translate(1 1)"/>
                <path stroke="#410062" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M6.523 22.475c.594.9 2.61 2.637 7.77 2.183 5.16-.454 6.322-.064 6.755-1.283.434-1.218-4.016-2.253-4.564-4.882-.548-2.63 1.943-1.447 2.354-2.9.41-1.452-2.258-2.799-1.088-4.335 1.17-1.537 4.255-5.698 3.543-7.068M41.755 7.276s-6.113 4.658-5.409 6.013c.705 1.356 1.863 1.416 4.171 1.067 2.308-.348 5.257-2.732 5.257-2.732" transform="translate(1 1)"/>
                <path fill="var(--brand-tertiary-3)" fill-rule="nonzero" stroke="#410062" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M18.625 59.254L39.506 59.254 42.116 64 16.015 64z" transform="translate(1 1)"/>
                <path stroke="#410062" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M29 53L29 59" transform="translate(1 1)"/>
                <path fill="var(--brand-tertiary-3)" fill-rule="nonzero" d="M29.659 42.644c1.424 1.424 2.57 3.56 2.966 4.746 2.768-1.187 7.01-.69 11.271-5.34 6.526-7.118 5.932-11.27 5.932-11.27s-2.266-2.373-8.898-2.373c-5.339 0-6.526-2.966-10.085-2.966-3.56 0-5.339 2.966-4.746 5.932.594 2.966-.593 3.56 0 6.525.368 1.84 1.78 2.966 3.56 4.746z" transform="translate(1 1)"/>
                <path stroke="#410062" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M39.639 45.169c11.214-5.83 15.579-19.649 9.748-30.863-5.83-11.215-19.649-15.58-30.863-9.749-11.215 5.83-15.58 19.649-9.749 30.863C14.606 46.635 28.424 51 39.64 45.17z" transform="translate(1 1)"/>
                <path stroke="#410062" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M32.625 47.39c-.396-1.187-1.543-3.322-2.966-4.746-1.78-1.78-3.192-2.906-3.56-4.746-.593-2.966.594-3.56 0-6.525-.593-2.966 1.187-5.932 4.746-5.932 3.56 0 4.746 2.966 10.085 2.966 6.632 0 9.492 2.966 9.492 2.966" transform="translate(1 1)"/>
            </g>
        </svg>
    `,
  styles: [``]
})
export class UnmissableIconComponent {
  constructor() { }
}

@Component({
  selector: 'image-icon',
  template: `
    <img [attr.src]="mediaIconUrl" loading="lazy" alt="icon">
    `,
  styles: [``]
})
export class ImageIconComponent {
  @Input() mediaIconUrl: string;
  constructor() { }
}